import axiosInstance from "./axiosInstance";

export const getCurrentUser = async () => {
  return await axiosInstance.get("/accounts/me/");
};

export const getProfileById = async (profileId) => {
  return await axiosInstance.get(`/accounts/profiles/${profileId}/`);
};

// ✅ NEW — username se bhi profile fetch (same endpoint, backend handles it)
export const getProfileByUsername = async (username) => {
  return await axiosInstance.get(`/accounts/profiles/${username}/`);
};

export const updateProfile = async (profileId, formData) => {
  return await axiosInstance.patch(
    `/accounts/profiles/${profileId}/`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

export const getSavedPosts = async () => {
  const response = await axiosInstance.get("/boards/");
  return response.data?.results || response.data || [];
};